import { render, staticRenderFns } from "./InserirDocumentosMetaConsultoria.vue?vue&type=template&id=bd5e4c4a"
import script from "./InserirDocumentosMetaConsultoria.vue?vue&type=script&lang=js"
export * from "./InserirDocumentosMetaConsultoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports